import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/public/Home.vue'
import Login from '../views/public/Login'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/login',
		name: 'Login',
		component: Login
	},
	{
		path: '/register',
		name: 'Register',
		component: () => import(/* webpackChunkName: "register" */ '../views/public/Register.vue')
	},
	{
		path: '/reset-password',
		name: 'ResetPassword',
		component: () => import(/* webpackChunkName: "register" */ '../views/public/PasswordReset.vue')
	},
	{
		path: '/verify-email',
		name: 'VerifyEmail',
		component: () => import(/* webpackChunkName: "register" */ '../views/public/VerifyEmail.vue')
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/private/dashboard/Dashboard.vue'),
		meta: {
			authRequired: true
		}
	},
	{
		path: '/my-company',
		name: 'MyCompany',
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/private/mycompany/MyCompany.vue'),
		meta: {
			authRequired: true
		}
	},
	{
		path: '/settings',
		name: 'Settings',
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/private/myprofile/MyProfile.vue'),
		meta: {
			authRequired: true
		}
	},
	{
		path: '/my-production-requests',
		name: 'MyProductionRequests',
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/private/myproductionrequests/MyProductionRequests.vue'),
		meta: {
			authRequired: true
		}
	},
	{
		path: '/my-production-offers',
		name: 'MyProductionOffers',
		component: () => import('../views/private/myproductionoffers/MyProductionOffers.vue'),
		meta: {
			authRequired: true
		}
	},
	{
		path: '/marketplace',
		name: 'Marketplace',
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/private/marketplace/Marketplace'),
		meta: {
			authRequired: true
		},
		children: [{
			path: '/marketplace/:prid',
			component: () => import(/* webpackChunkName: "dashboard" */ '../views/private/marketplace/PRDetailsDialog.vue')
		}]
	},
	{
		path: '/admin',
		name: 'Admin',
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/private/admin/Admin'),
		meta: {
			authRequired: true
		}
	},
	{
		path: '/logout',
		name: 'Logout',
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/public/Logout.vue'),
		meta: {
			logout: true
		}
	}
]

const router = new VueRouter({
	routes,
	mode: 'history'
})

router.beforeEach((to, from, next) => {
	const loggedIn = localStorage.getItem('user')
	if (to.matched.some(record => record.meta.authRequired) && !loggedIn) {
		next('/login')
		return
	}
	next()
})

export default router
